import React from "react";

interface IconMarketing2Props {
    width?: number;
    height?: number;
    color?: string;
}

const IconMarketing2: React.FC<IconMarketing2Props> = ({
    width = 38,
    height = 38,
    color = "#EE8113",
}) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 38 38"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <circle cx="19" cy="19" r="19" fill={color} />
            <g transform="translate(-1.3, -1)">
                <path
                    d="M27.14 20.75H21.82v9h5.32a.7.7 0 0 0 .7-.71V21.46a.7.7 0 0 0-.7-.71Z"
                    fill="white"
                />
                <path
                    d="M13.16 21.46V29a.7.7 0 0 0 .7.71h5.32v-9H13.86a.7.7 0 0 0-.7.71Z"
                    fill="white"
                />
                <path
                    d="M12.2 17v2.21a.7.7 0 0 0 .7.7h6.28V16.3H12.9a.7.7 0 0 0-.7.7Z"
                    fill="white"
                />
                <path
                    d="M28.1 16.3H21.8l0 3.61H28.1a.7.7 0 0 0 .7-.7V17a.7.7 0 0 0-.7-.7Z"
                    fill="white"
                />
                <path
                    d="M15.11 15.5a1.05 1.05 0 0 0 .59.12h9.51a1.23 1.23 0 0 0 .66-.13 2.38 2.38 0 0 0 1-2.14 3.45 3.45 0 0 0-.64-2 2.54 2.54 0 0 0-2.08-1H24c-2.21.15-3.12 2.26-3.47 3.62-.35-1.36-1.25-3.47-3.47-3.62H16.8a2.55 2.55 0 0 0-2.09 1 3.45 3.45 0 0 0-.64 2 2.37 2.37 0 0 0 1.04 2.14ZM24 11.56h.13a1.29 1.29 0 0 1 1.07.53 2.2 2.2 0 0 1 .39 1.27c0 .38-.14 1.12-.65 1.12H21.65c.23-1.03.85-2.82 2.35-2.92Zm-8.31.52a1.27 1.27 0 0 1 1.07-.53h.12c1.54.1 2.16 1.89 2.39 2.91H16c-.51 0-.64-.74-.64-1.12a2.13 2.13 0 0 1 .33-1.26Z"
                    fill="white"
                />
            </g>
        </svg>
    );
};

export default IconMarketing2;
